import React, { createContext, useCallback, useContext, useMemo, useReducer } from "react"
import { toastReducer } from "../shared/toast-reducer"
import ToastsContainer from "../shared/toast-container"

export const ToastContext = createContext()

const initialState = {
  toasts: [],
}

export const ToastContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(toastReducer, initialState)

  const addToast = useCallback((type, message) => {
    const id = Math.floor(Math.random() * 10000000)
    dispatch({ type: "ADD_TOAST", payload: { id, message, type } })
  }, [])

  const success = useCallback(
    (message) => {
      addToast("success", message)
    },
    [addToast],
  )

  const warning = useCallback(
    (message) => {
      addToast("warning", message)
    },
    [addToast],
  )

  const info = useCallback(
    (message) => {
      addToast("info", message)
    },
    [addToast],
  )

  const error = useCallback(
    (message) => {
      addToast("error", message)
    },
    [addToast],
  )

  const remove = useCallback(
    (id) => {
      dispatch({ type: "DELETE_TOAST", payload: id })
    },
    [dispatch],
  )

  const clearAllToast = useCallback(() => {
    dispatch({ type: "DELETE_ALL_TOASTS" })
  }, [dispatch])

  const value = useMemo(
    () => ({ success, warning, info, error, remove, clearAllToast }),
    [success, warning, info, error, remove, clearAllToast],
  )

  return (
    <ToastContext.Provider value={value}>
      <ToastsContainer toasts={state.toasts} removeToast={remove} />
      {children}
    </ToastContext.Provider>
  )
}

export const useToast = () => {
  const context = useContext(ToastContext)

  if (!context) {
    throw new Error("useToast must be used within ToastContextProvider")
  }

  return context
}
